/**
 * Charcot Frontend App
 * 📖 Pour comprendre l'architecture complète : voir /AI_CONTEXT.md
 */

import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import './theme';

import ErrorBoundary from './components/ErrorBoundary';
import SkeletonLoader from './components/SkeletonLoader';
import { lazyWithRetry } from './utils/lazyWithRetry';

// Code splitting : chaque page est chargée à la demande.
// lazyWithRetry ajoute une reprise (retry puis rechargement unique) en cas
// d'échec de chargement d'un chunk — voir src/utils/lazyWithRetry.js
const Chirurgie = lazyWithRetry(() => import('./pages/Chirurgie'), 'Chirurgie');
const Consultation = lazyWithRetry(() => import('./pages/Consultation'), 'Consultation');
const Douleurs = lazyWithRetry(() => import('./pages/Douleurs'), 'Douleurs');
const Home = lazyWithRetry(() => import('./pages/Home'), 'Home');
const NotFound = lazyWithRetry(() => import('./pages/NotFound'), 'NotFound');
const Pathologie = lazyWithRetry(() => import('./pages/Pathologie'), 'Pathologie');
const Pathologies = lazyWithRetry(() => import('./pages/Pathologies'), 'Pathologies');
const PostChirurgie = lazyWithRetry(() => import('./pages/PostChirurgie'), 'PostChirurgie');
const PostConsultation = lazyWithRetry(() => import('./pages/PostConsultation'), 'PostConsultation');
const ProSante = lazyWithRetry(() => import('./pages/ProSante'), 'ProSante');

function App() {
  return (
    <HelmetProvider>
      <Router>
        {/* Lien d'évitement pour navigation clavier (WCAG 2.4.1) */}
        <a className="skip-to-content" href="#main-content">
          Aller au contenu principal
        </a>
        <div className="app-shell">
          {/* Garde-fou : évite la page blanche si un chunk ne peut pas être chargé */}
          <ErrorBoundary>
            <Suspense fallback={<SkeletonLoader count={3} variant="card" />}>
              <Routes>
                <Route element={<Home />} path="/" />
                <Route element={<Consultation />} path="/consultation" />
                <Route element={<Douleurs />} path="/douleurs" />
                <Route element={<PostConsultation />} path="/post-consultation" />
                <Route element={<Chirurgie />} path="/chirurgie" />
                <Route element={<PostChirurgie />} path="/post-chirurgie" />
                <Route element={<Pathologies />} path="/pathologies" />
                <Route element={<Pathologie />} path="/pathologies/:slug" />
                <Route element={<ProSante />} path="/pro" />
                <Route element={<NotFound />} path="*" />
              </Routes>
            </Suspense>
          </ErrorBoundary>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
